module.exports = __webpack_public_path__ + "static/media/my-team.6d95dbaf.svg";